import { Component, OnInit, Input, Output, EventEmitter, ComponentFactoryResolver, ViewContainerRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../../../services/api/api.service';
import { ViewType } from '../../../../framework/core/Enums';
import { FormBuilderControl } from '../../../../common/formbuilder/FormBuilderControl';
import { IControlChangeEventArgs } from '../../../../common/formbuilder/IControlChangeEventArgs';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';

@Component({
  selector: 'app-custom-control-stock-item-auto-complete',
  templateUrl: './custom-control-stock-item-auto-complete.component.html',
  styleUrls: ['./custom-control-stock-item-auto-complete.component.css']
})
export class CustomControlStockItemAutoCompleteComponent implements OnInit {
  public loadingProgress: boolean;
  private _formField: FormBuilderControl;
  private _data: any = {};
  @Input() public formReadOnly: boolean;
  public showUpload: boolean = false;
  public dataAutoComplete: any;
  public loading: boolean = false;
  public customControlInstance: any;
  public get formField(): FormBuilderControl { return this._formField; }
  public get fieldDisabled() {
    if (this.formReadOnly)
      return true;
    if (this.formField.disabled)
      return true;
    if (this.formField.fieldOptions && this.formField.fieldOptions.readOnly) {
      if ({}.toString.call(this.formField.fieldOptions.readOnly) === '[object Function]') {
        let test: any = this.formField.fieldOptions.readOnly;
        return test(this.data)
      }
      else return this.formField.fieldOptions.readOnly;
    }
  }
  private _dataObj: any;
  @Input() set dataObj(val) {
    this._dataObj = val;
    //this.dataObjChange.emit(val);
    if (this.customControlInstance) {
      this.customControlInstance.component.dataObj = this.dataObj;
    }
  }
  public get getDisplayValue() {
   
      return this.dataAutoComplete ? this.dataAutoComplete.label : "";
   
  }

  get dataObj() {
    return this._dataObj;
  }
  _parent: any;
  @Input() set parent(value) {
    this._parent = value;
  }
  get parent() {
    return this._parent;
  }
  @Input() extraData: any;
  @Input() public set formField(value: FormBuilderControl) { this._formField = value; }
  public get data() { return this._data; }
  @Input() public set data(value) {
    
      if (value != '' && value != null && !value.value)
        this.getInitialAutoCompleteValue(value);
      else this.dataAutoComplete = null;
    
    //else {
    //  let old = this._data;
    //  if (this.formField.controlType.viewType == ViewType.Date && value != '' && value != null) {
    //    let sa = new Date(value);
    //    this._data = new Date(sa.setTime(sa.getTime() + ((sa.getTimezoneOffset() * 60 * 1000) * -1)))
    //  }
    //  else this._data = value;
    //  this.dataChange.emit(value);
    //  if (this.formField.fieldOptions && this.formField.fieldOptions.change)
    //    this.formField.fieldOptions.change(old, this._data, this.dataObj, this);
    //  if (this.customControlInstance) {
    //    this.customControlInstance.component.data = this.data;
      //}
    //}

  }
  public viewType = ViewType;

  constructor(public apiService: ApiService, private componentFactoryResolver?: ComponentFactoryResolver, private authService?: IdentityAuthService,
    private cdr?: ChangeDetectorRef) { }

  public ngOnInit() {

    if (this.formField.controlType.viewType == ViewType.String && this.formField.fieldOptions && this.formField.fieldOptions.dataEndPoint) {
      this.formField.controlType.viewType = ViewType.Dropdown;
    }
    if (this.formField.controlType.viewType == ViewType.Dropdown && this.formField.fieldOptions && this.formField.fieldOptions.dataEndPoint)
      this.apiService.get(this.formField.fieldOptions.dataEndPoint.url)
        .subscribe(items => {
          this.formField.lookups = items.map(o => { return { value: o[this.formField.fieldOptions.dataIdField], label: o[this.formField.fieldOptions.dataDisplayField] } })
        }, error => { });


  }
  @Output() public dataChange = new EventEmitter();
  @Output() public dataObjChange = new EventEmitter();
  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();

  public controlDataChange(formBuilderControl: FormBuilderControl, value: any) {
    if (typeof value != "undefined")
      this.onControlDataChange.emit({ formBuilderControl: formBuilderControl, controlValue: value, extraData: this.extraData, context: this });
  }



  public getInitialAutoCompleteValue(val) {
    if (this.dataAutoComplete && this.dataAutoComplete.value == val)
      return;
    this.formField.disabled = true;
    this.apiService.get(`/api/stockItem/detailedItem/` + val)
      .subscribe(item => {
        debugger;
        this.formField.disabled = false;

        item.stockItemSuppliers.forEach(o => {
          o.stockItem = {
            code: item.code,
            description: item.description,
            id: item.id,
            name: item.name,
            minOrderQuantity: item.minOrderQuantity,
            packagingQuantity: item.packagingQuantity,
            unitOfMeasureDescription: item.unitOfMeasure,
            generalLedgerId: item.generalLedgerId,
            hierarchyId: item.hierarchyId
          }
          o.initial = true;
        });
        this.dataObj.stockItemSuppliers = item.stockItemSuppliers;
        this.dataAutoComplete = { value: val, label: item['description'], stockItemSuppliers: item.stockItemSuppliers };
        if (this.formField.fieldOptions && this.formField.fieldOptions.change)
          this.formField.fieldOptions.change(null, this._data, this.dataObj, this);
        this.cdr.detectChanges();
      }, error => { });
  }

  public onAutocompleteSelect(selectedValue, data) {
    let reqItem = data.dataObj;
    selectedValue.stockItemSuppliers.forEach(o => {
      o.stockItem = {
        code: selectedValue.code,
        description: selectedValue.description,
        id: selectedValue.id,
        name: selectedValue.name,
        minOrderQuantity: selectedValue.minOrderQuantity,
        packagingQuantity: selectedValue.packagingQuantity,
        unitOfMeasureDescription: selectedValue.unitOfMeasureDescription,
        generalLedgerId: selectedValue.generalLedgerId,
        hierarchyId: selectedValue.hierarchyId,
        
      }
      o.initial = false;
    });
    reqItem.stockItemSuppliers = selectedValue.stockItemSuppliers;
    this.dataObj[this.formField.field] = selectedValue.id;
    this.dataAutoComplete = selectedValue;

    if (this.formField.fieldOptions && this.formField.fieldOptions.change)
      this.formField.fieldOptions.change(null, this._data, this.dataObj, this);
    this.cdr.detectChanges();
  }

  public search($event, formField: FormBuilderControl, data) {
    this.loadingProgress = true;
    this.apiService.post(`/api/stockItem/detailedListWithSuppliers/` + this.parent.parent.parent.parent.previousEntityId, {
      startRecNum: 0,
      rows: 50,
      query: $event.query
    })
      .subscribe(stockItems => {
        formField.lookups = new Array();
        stockItems.list.forEach(o => {
          if (o.fileCabinets)
            o.images = o.fileCabinets.map(o => {
              return { source: this.apiService.appSettings.apiServiceAddress + "/api/FileCabinetDocument/getImageSmall/" + o, alt: 'Description for Image 1', title: 'Title 1' }
            });
        })
        this.loadingProgress = false;
        //if (stockItems.list.length == 0) {
        //stockItems.list.push({
        //  name: "Item not found",
        //  code: "000",
        //  description: "Add new item. Select if you could not find your item from the list",
        //  id: '00000000-0000-0000-0000-000000000000'
        //});
        // }
        formField.lookups = stockItems.list;
        this.cdr.detectChanges();
      }, err => {

          this.loadingProgress = false;
      });
  }

}
